import _ from "lodash";

import { updateItemsInArray } from "utils/reducerUtils";

import {
  FetchStockMovementsSuccessAction,
  UpdateStockMovementStatusSuccessActionCreator,
} from "./actionCreators";
import * as types from "./actionTypes";
import initialState from "./initialState";

export interface IStockMovementState {
  stock_movements: IFrontendStockMovement[];
  loading: boolean;
}

export interface IFrontendStockMovement {
  id: string;
  user_id: string;
  user_name?: string;
  storage_id: string;
  storage_name?: string;
  mode: string;
  requested: Array<{
    sku_id: string;
    sku_name?: string;
    requested_quantity: number;
  }>;
  status: string;
  created_at?: Date;
  updated_at?: Date;
  created_by: string;
  updated_by: string;
}

export default function reducer(state = initialState, action: any) {
  switch (action.type) {
    case types.UPDATE_STOCK_MOVEMENT_STATUS_BEGIN:
    case types.FETCH_STOCK_MOVEMENTS_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case types.UPDATE_STOCK_MOVEMENT_STATUS_FAILURE:
    case types.FETCH_STOCK_MOVEMENTS_FAILURE:
      return {
        ...state,
        loading: false,
      };

    case types.FETCH_STOCK_MOVEMENTS_SUCCESS: {
      const { stock_movements, append } =
        action as FetchStockMovementsSuccessAction;

      let newStockMovements: IFrontendStockMovement[] = stock_movements;
      if (append) {
        newStockMovements = _.concat(state.stock_movements, stock_movements);
      }

      return {
        ...state,
        loading: false,
        stock_movements: newStockMovements,
      };
    }

    case types.UPDATE_STOCK_MOVEMENT_STATUS_SUCCESS: {
      const { stock_movements: stockMovements } =
        action as UpdateStockMovementStatusSuccessActionCreator;

      const newStockMovements = _.forEach(state.stock_movements, (movement) => {
        const updated = _.find(stockMovements, { id: movement.id });
        if (updated) {
          movement.status = updated.status;
        }
      });

      return {
        ...state,
        loading: false,
        stock_movements: updateItemsInArray(
          state.stock_movements,
          newStockMovements,
        ),
      };
    }

    default:
      return state;
  }
}
